import { render, staticRenderFns } from "./VacancyContact.vue?vue&type=template&id=2ebdf125&scoped=true"
import script from "./VacancyContact.vue?vue&type=script&lang=js"
export * from "./VacancyContact.vue?vue&type=script&lang=js"
import style0 from "./VacancyContact.vue?vue&type=style&index=0&id=2ebdf125&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebdf125",
  null
  
)

export default component.exports